import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "../tools/Redirect";
import { screeningResultSelector } from '../../modules/screening/selectors';
import { AuthComp } from '../../auth/AuthComp';
import { LOGIN } from '../../global/urlMapping';
import { getScreeningResultAction } from '../../modules/screening/actions';
import { EsitiLayout } from '../common/EsitiLayout';
import { isAuthenticatedSelector } from '../../modules/auth/selectors';
import { postLoginSelector } from '../../modules/postLogin/selectors';
import { SUCCEDED } from '../../global/statusLabels';

export const Esiti = () => {
    const dispatch = useDispatch()
    const screeningResult = useSelector(screeningResultSelector);
    const isAuthenticated = useSelector(isAuthenticatedSelector)
    const postLogin = useSelector(postLoginSelector)

    useEffect(() => {
        window.scrollTo(0, 0)
        if (isAuthenticated && postLogin?.status === SUCCEDED) {
            dispatch(getScreeningResultAction())
        }
    }, [dispatch, isAuthenticated, postLogin])
    return (
        <AuthComp fallback={< Redirect link={LOGIN} />} >
            <EsitiLayout esiti={screeningResult?.value?.screeningResults} />
        </AuthComp>
    );

}